type MarkdownModule = typeof import("marked");
type DOMPurifyModule = typeof import("dompurify");

let markdownLibPromise: Promise<{
  markedModule: MarkdownModule;
  domPurifyModule: DOMPurifyModule;
}> | null = null;

async function getMarkdownLibraries() {
  if (!markdownLibPromise) {
    markdownLibPromise = Promise.all([
      import("marked"),
      import("dompurify"),
    ]).then(([markedModule, domPurifyModule]) => {
      markedModule.marked.setOptions({ async: false });
      return { markedModule, domPurifyModule };
    });
  }
  return markdownLibPromise;
}

export async function renderMarkdown(content: string): Promise<string> {
  const { markedModule, domPurifyModule } = await getMarkdownLibraries();
  const html = markedModule.marked.parse(content) as string;
  const wrapped = html
    .replace(/<table/g, '<div style="overflow-x:auto;max-width:100%"><table')
    .replace(/<\/table>/g, "</table></div>");
  return domPurifyModule.default.sanitize(wrapped);
}

export async function sanitizeHtml(content: string): Promise<string> {
  const { domPurifyModule } = await getMarkdownLibraries();
  return domPurifyModule.default.sanitize(content);
}
